import type MiniUser from '../../../../types/MiniUser';
import { search } from '../../../api/custom/QueryUsersJson';
import { getCurrentUser } from '../CurrentUser';
import { getManagersReports } from '../User';
import { refineSearchResult } from './search-users-helper';

const currentUser = getCurrentUser();

interface SearchResult {
    query: string;
    config: any;
    result: MiniUser[];
}

export function searchForUsers(searchResult: SearchResult) {
    return Promise.all([search(searchResult.query, searchResult.config), getManagersReports(currentUser)])
        .then(([result, managerReports]) => refineSearchResult(currentUser, managerReports, searchResult, result))
        .catch(() => searchResult);
}
